// removed by extract-text-webpack-plugin
module.exports = {"anim_body":"slideWorks_wUVaHdb","anim_element":"slideWorks_2MnEIlb","bg":"slideWorks_G7vdiN9","thumb":"slideWorks_2nosJSl","inactive":"slideWorks_2z3Kmoe","active":"slideWorks_2gothS6"};


//////////////////
// WEBPACK FOOTER
// ./src/component/rec/slideWorks/slideWorks.css
// module id = 840
// module chunks = 0